import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, SuccessButton, FilterCategory } from "../..";
import { GREY_LIGHT } from "../../styles/shared/colors";
import "./FiltersPanel.scss";
import closeIcon from "../../assets/imgs/icon-close.svg";

const FilterOrder = [
  'events',
  'players',
  'periods',
  'positions',
]

const FiltersPanel = ({
  filters,
  handleItemClick,
  handleClearFilters,
  currentFilters,
  handleClosePanel,
  handleSaveFilters
}) => {
  const sortedEvents = []
  FilterOrder.map(category => sortedEvents.push(filters[category]));
  return (
    <div className="filters-panel">
      <button
        type="button"
        onClick={handleClosePanel}
        style={{ alignSelf: "flex-end" }}
      >
        <img className="filters-panel__close-icon" src={closeIcon} alt="" />
      </button>
      <div className='filters-panel__categories-wrapper'>
        {sortedEvents.map((category, i) => {
          const currentKey = FilterOrder[i];
          return (
            category.length > 0 && (
              <FilterCategory
                key={currentKey}
                category={category}
                categoryName={currentKey}
                hasSeparator={i < FilterOrder.length - 1}
                onItemClick={handleItemClick}
                currentCategoryFilter={currentFilters[currentKey]}
              />
            )
          );
        })}
      </div>
      <div className="filters-panel__buttons">
        <PrimaryButton color={GREY_LIGHT} showBorder onClick={handleClearFilters}>
          CLEAR FILTERS
        </PrimaryButton>
        <SuccessButton onClick={handleSaveFilters}>SAVE</SuccessButton>
      </div>
    </div>
  );
}


FiltersPanel.propTypes = {
  currentFilters: PropTypes.object,
  filters: PropTypes.object,
  handleClearFilters: PropTypes.func,
  handleClosePanel: PropTypes.func,
  handleItemClick: PropTypes.func,
  handleSaveFilters: PropTypes.func
};

FiltersPanel.defaultProps = {
  currentFilters: {},
  filters: {},
  handleClearFilters: () => {},
  handleClosePanel: () => {},
  handleItemClick: () => {},
  handleSaveFilters: () => {}
};

export default FiltersPanel;
